import "./Stafi.css";
import foto1 from "../assets/Artboard 1 (2).jpg";
import foto2 from "../assets/Artboard 2 (2).jpg";
import foto3 from "../assets/Artboard 5 (1).jpg";
import foto4 from "../assets/Artboard 3 (3).jpg";
import { Footer } from "./Footer";

const staff = [
  {
    name: "Art Abdyli",
    role: "Udhëheqës i trajnimeve në dizajn grafik",
    color: "#ff6600", // orange
    img: foto1
  },
  {
    name: "Berat Rakovica",
    role: "Drejtor Ekzekutiv (CEO)",
    color: "#fff",
    img: foto2
  },
  {
    name: "Anisa Sejdija",
    role: "Dizajnere Grafike",
    color: "#111",
    img: foto3
  },
  {
    name: "Shkelqim Ibishi",
    role: "Trajner i foto-video & motion graphics",
    color: "#ff6600",
    img: foto4
  },
  {
    name: "Agenesa Gashi",
    role: "Menaxhere e mediave sociale",
    color: "#fff",
    img: foto4
  },
  
  {
    name: "Floresa Zogaj",
    role: "Zhvilluese Web-it",
    color: "#111",
    img: foto4
  },
  
];

export function Stafi() {
  return (
    <>
    <section className="fox-staff-section">
      <h1 className="fox-staff-title">Stafi <span>Fox Academy</span></h1>
      <div className="fox-staff-grid">
        {staff.map((person, i) => (
          <div className="fox-staff-card" key={i}>
            <div
              className="fox-staff-card-top"
              style={{
                background: person.color,
                color: person.color === "#111" ? "#fff" : "#111"
              }}
            >
              <span className="fox-staff-name">{person.name}</span>
            </div>
            <div className="fox-staff-img-wrap">
              <img src={person.img} alt={person.name} />
            </div>
            <div className="fox-staff-role">{person.role}</div>
          </div>
        ))}
      </div>
    </section>
    <Footer/>
    </>
  );
}
